export const MAX_CLUB_LOGO_BYTES = 5 * 1024 * 1024;

const IMAGE_EXT = /\.(jpe?g|png|webp|gif|svg|heic|heif)$/i;

export function validateClubLogoFile(file) {
  if (!file) {
    return { ok: false, messageKey: "clubLogoInvalidType" };
  }
  if (Number(file.size) > MAX_CLUB_LOGO_BYTES) {
    return { ok: false, messageKey: "clubLogoTooLarge" };
  }
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "");
  if (type.startsWith("image/") || IMAGE_EXT.test(name)) {
    return { ok: true };
  }
  return { ok: false, messageKey: "clubLogoInvalidType" };
}
